export const premium = [
  {
    id: 1,
    name: "Honda City AC",
    image: "/images/gallery/premium/honda-city.png",

    gallery: [
      "/images/gallery/premium/honda-city.png",
      "/images/gallery/premium/honda-city-interior.jpg",
      "/images/gallery/premium/honda-city-back.jpg"
    ],

    body: "Sedan",
    seats: "4 + 1",
    doors: "4",
    engine: "1498 cc",
    transmission: "Manual / Automatic",
    fuel: "Petrol",
    ac: "AC"
  },

  // {
  //   id: 2,
  //   name: "Toyota Corolla Altis AC",
  //   image: "/images/gallery/premium/corolla-altis.png",

  //   gallery: [
  //     "/images/gallery/premium/corolla-altis.png",
  //     "/images/gallery/premium/corolla-altis-interior.jpg",
  //     "/images/gallery/premium/corolla-altis-back.jpg"
  //   ],

  //   body: "Sedan",
  //   seats: "4 + 1",
  //   doors: "4",
  //   engine: "1798 cc",
  //   transmission: "Manual / Automatic",
  //   fuel: "Petrol",
  //   ac: "AC"
  // },

  {
    id: 3,
    name: "Maruti Ciaz AC",
    image: "/images/gallery/premium/maruti-ciaz.png",

    gallery: [
      "/images/gallery/premium/maruti-ciaz.png",
      "/images/gallery/premium/maruti-ciaz-interior.jpg",
      "/images/gallery/premium/maruti-ciaz-back.jpg"
    ],

    body: "Sedan",
    seats: "4 + 1",
    doors: "4",
    engine: "1462 cc",
    transmission: "Manual / Automatic",
    fuel: "Petrol",
    ac: "AC"
  }
];
